const KEY_BACKSPACE = 'Backspace';
const KEY_DELETE = 'Delete';
const KEY_F2 = 'F2';

class customCellEditor {
  init(params) {
    this.gui = document.createElement('input');
    this.gui.type = 'text';
    this.gui.classList.add('my-simple-editor');

    this.params = params;

    let startValue = params.value;

    const isBackspaceOrDelete =
      params.eventKey === KEY_BACKSPACE || params.eventKey === KEY_DELETE;
    if (isBackspaceOrDelete) {
      startValue = '';
    } else if (params.charPress) {
      startValue = params.charPress;
    }
    if (startValue !== null && startValue !== undefined && startValue !== "") {
      if(this.isDateValue(startValue)){
        this.gui.value = this.handledateFormatter(startValue);
      } else if(this.isLetter(startValue) === null){
        this.gui.value = this.getCellFormattedValue(startValue);
      } else {
        this.gui.value = startValue;
      }
      //this.gui.value = this.isLetter(startValue) === null ? this.getCellFormattedValue(startValue) : startValue;
    }else {
      this.gui.value = "";
    }

  }

  handledateFormatter(value){
    var date = new Date(value);
    return (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear());
  }

  isDateValue(value) {
    var dateString = value.toString().substring(0,10);
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if(!dateString.match(regEx)) return false;  // Invalid format
    var d = new Date(dateString);
    var dNum = d.getTime();
    if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0,10) === dateString;
  }

  isLetter(str) {
      var regexp = /[A-Za-z_/-]/i;
      return regexp.exec(str);
  }

  getCellFormattedValue(value) {
    if(value === undefined || value == "" || value === null || value == '(NaN)'){
        return 0;
    } else {
        var regExp = /\(([^)]+)\)/;
        value = value.toString().replace(/,/g, '');
        var match = regExp.exec(value);
        var data = (match === null) ? value : '-'+match[1];
        var result = parseFloat(parseFloat(data).toFixed(2));
        return result;
    }
  }

    handleNegetiveValue(value){
        value = value.toString().replace(/,/g, '');
        var result = parseFloat(value) >= 0 ? value : '('+(Math.abs(value))+')';
        return result.replace(/\B(?=(\d{3})+(?!\d))/g, ','); 
    }

  getGui() {
    return this.gui;
  }

  getValue() {
    return this.gui.value;
  }

  afterGuiAttached() {
    this.gui.focus();
  }

  myCustomFunction() {
    return {
      rowIndex: this.params.rowIndex,
      colId: this.params.column.getId(),
    };
  }
}

export { customCellEditor }